import React from 'react';
import CyclomaticCard from './CyclomaticCard';
import MaintainabilityCard from './MaintainabilityCard';
import NumberImportsCard from './NumberImportsCard';
import SecurityCard from './SecurityCard';
import CommentDensityCard from './CommentDensityCard';
import SizeLinesCard from './SizeLinesCard';
import NumberParametersCard from './NumberParametersCard';

const MetricsSection = (props) => {
    
    const{
        metricsData
    } = props;

    return(
        <div style={{marginTop: '2rem'}}>
            <div style={{fontWeight: '500', fontSize: '1.5rem'}}>Project Metrics</div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '2rem'}}>
                <CyclomaticCard metricsData={metricsData}/>
                <MaintainabilityCard metricsData={metricsData}/>
                <NumberImportsCard metricsData={metricsData}/>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '2rem'}}>
                <SecurityCard metricsData={metricsData}/>
                <CommentDensityCard metricsData={metricsData}/>
                <SizeLinesCard metricsData={metricsData}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '3rem'}}>
                <NumberParametersCard metricsData={metricsData}/>
            </div>
            
        </div>
    )


}
 
export default MetricsSection;
